<template>
  <v-card class="box-container ma-0 pa-2" align="center" justify="center" :width="getWidth">
    <v-card-actions class="row-header ma-0 pa-4">
      <v-col class="ma-0 pa-0">
        <v-row class="ma-0 pa-0" align="center" justify="center">
          <span>{{ title }}</span>
        </v-row>
        <v-divider></v-divider>
        <v-row class="ma-0 pa-0" align="center" justify="center" v-if="!hideSearch">
          <v-text-field v-model="searchText" :label="multiple ? s_Search : s_SearchSort" hide-details></v-text-field>
        </v-row>
      </v-col>
    </v-card-actions>
    <v-card-actions class="row-content">
      <v-col class="ma-0 pa-0" style="max-height: 400px">
        <v-row v-if="searchText && getData.length == 0" style="height: 40px" align="center" justify="center" class="ma-0 pa-0">
          <span>{{ s_DataNotFound }}</span>
        </v-row>
        <v-row class="ma-0 pa-0" v-if="multiple" style="max-height: 400px">
          <v-virtual-scroll ref="refVirtualScroll" :height="400 - (searchText && getData.length == 0 ? 40 : 0)" :item-height="getButtonsHeight()" :items="getData" :width="getWidth">
            <template v-slot="{ item, index }">
              <!-- <v-checkbox class="ma-0 pa-0 px-2" :ripple="false" hide-details multiple :persistent-hint="true" v-model="selected" :value="item" :label="item.toString()" :color="isInDarkMode ? '' : 'grey'"></v-checkbox> -->
              <v-switch inset class="ma-0 pa-0 px-2" multiple dense v-model="selected" :value="item" hide-details :color="Colors.IconColor">
                <template v-slot:label>
                  <v-tooltip v-if="tooltipFn" :disabled="hideTooltips" right>
                    <template v-slot:activator="{ on }">
                      <span v-on="on" :style="(isOnMobile ? 'font-size: 14px; ' : 'font-size: 14px;') + (lastFoundIdx != null && index == lastFoundIdx ? 'text-decoration: underline;' : '')">{{ (toStringFn ? toStringFn(item) : item.toString()).padRight(50, " ").substring(0, 50) }}</span>
                    </template>
                    {{ tooltipFn(item) }}
                  </v-tooltip>
                  <span v-else :style="(isOnMobile ? 'font-size: 14px; ' : 'font-size: 14px;') + (lastFoundIdx != null && index == lastFoundIdx ? 'text-decoration: underline;' : '')">{{ (toStringFn ? toStringFn(item) : item.toString()).padRight(50, " ").substring(0, 50) }}</span>
                </template>
              </v-switch>
            </template>
          </v-virtual-scroll>
        </v-row>
        <div v-else :style="'max-height: ' + (getButtonsHeight() * 10 + 4) + 'px'">
          <v-row v-for="(item, idx) in getData" :key="idx" class="ma-0 pa-0" align="center" justify="center">
            <v-btn class="ma-1 pa-1" outlined @click="itemClick(item)" :style="selected == item ? 'background: ' + Colors.ActiveItemBackground + '; font-weight: bold;' : ''" width="100%">
              <v-icon v-if="item.icon" class="pr-2" :color="Colors.IconColor">{{ item.icon }}</v-icon>
              {{ (toStringFn ? toStringFn(item) : item.toString()).padRight(50, " ").substring(0, 50) }}</v-btn
            >
          </v-row>
        </div>
      </v-col>
    </v-card-actions>
    <v-card-actions class="row-header ma-0 pa-0">
      <v-col>
        <v-row v-if="labelSelected" class="ma-2 pa-0" align="center">
          <span>{{ s_Picker_Chosen + ": " + selectedText() }}</span>
        </v-row>
        <v-row class="ma-2 pa-0" align="center" justify="center">
          <v-col cols="5" class="ma-0 pa-0" justify="start">
            <t-button :elevation="5" v-if="buttonCancelText" :btnText="buttonCancelText" :width="isOnMobile ? '120' : '150'" style="display: flex; cursor: pointer" @click.native="selectItem(false)"> </t-button>
          </v-col>
          <v-col cols="2" class="ma-0 pa-0"></v-col>
          <v-col cols="5" class="ma-0 pa-0">
            <t-button :elevation="5" v-if="buttonOKText" :btnIcon="'mdi-check'" :width="isOnMobile ? '120' : '150'" :btnText="buttonOKText" style="display: flex; cursor: pointer" @click.native="selectItem(true)"> </t-button>
          </v-col>
        </v-row>
      </v-col>
    </v-card-actions>
  </v-card>
</template>

<script>
import { g_Dialog, TR } from "../../main";
export default {
  props: {},
  data() {
    return {
      data: [],
      title: "",
      allowEmpty: false,
      buttonOKText: TR.OK,
      buttonCancelText: TR.Cancel,
      searchText: "",
      lastFoundIdx: null,
      selected: null,
      multiple: false,
      labelSelected: false,
      hideSearch: false,
      toStringFn: undefined,
      tooltipFn: undefined,
      width: null,
      s_SearchSort: TR.SearchSort,
      s_Search: TR.Search,
      s_DataNotFound: TR.DataNotFound,
      s_Picker_Chosen: TR.Picker_Chosen,
      s_NothingChosen: TR.NothingChosen,
      s_Choice: TR.Choice,
    };
  },
  computed: {
    getWidth() {
      return this.width ? this.width : this.isOnMobile ? 400 : 700;
    },
    getData() {
      if (this.toStringFn) {
        return this.data.filter((d) => this.toStringFn(d).toLowerCase().contains(this.searchText.toLowerCase()));
      } else {
        return this.data.filter((d) => d.toString().toLowerCase().contains(this.searchText.toLowerCase()));
      }
    },
  },
  methods: {
    selectedText() {
      return this.selected ? this.selected.map((s) => s.toString()).join(", ") : "";
    },
    getButtonsHeight() {
      return this.isOnMobile ? 50 : 30;
    },
    itemClick(item) {
      this.selected = item;
      if (!this.buttonOKText && !this.buttonCancelText) {
        this.selectItem(true);
      }
    },
    selectItem(confirm) {
      if (confirm) {
        if ((this.selected instanceof Array && this.selected.length == 0 && !this.allowEmpty) || !this.selected) {
          this.dialogLoader.showError(this.s_NothingChosen, { location: "center" });
          return;
        }
      } else {
        this.selected = null;
      }
      g_Dialog.result = this.selected;
      g_Dialog.close();
    },
  },
  watch: {
    // searchText(newVal) {
    //   if (!newVal) {
    //     this.lastFoundIdx = null;
    //   } else if (this.multiple) {
    //     var found = this.data.find(f =>
    //       f
    //         .toString()
    //         .toLowerCase()
    //         .contains(newVal.toLowerCase()),
    //     );
    //     if (found) {
    //       this.lastFoundIdx = this.data.indexOf(found);
    //       // this.$refs.refVirtualScroll.$el.scrollTo(0, this.lastFoundIdx * this.getButtonsHeight());
    //     } else {
    //       this.lastFoundIdx = null;
    //     }
    //   }
    // },
  },
  created() {
    this.data = g_Dialog.data;
    if (g_Dialog.options) {
      this.title = g_Dialog.options.title || this.s_Choice;
      if (g_Dialog.options.multiple) {
        this.multiple = g_Dialog.options.multiple;
      }
      if (g_Dialog.options.labelSelected) {
        this.labelSelected = g_Dialog.options.labelSelected;
      }
      if (g_Dialog.options.selected) {
        this.selected = g_Dialog.options.selected;
      } else {
        this.selected = [];
      }
      if (g_Dialog.options.hideSearch) {
        this.hideSearch = true;
      }
      if (g_Dialog.options.allowEmpty) {
        this.allowEmpty = true;
      }
      if (g_Dialog.options.buttonOKText != undefined) {
        this.buttonOKText = g_Dialog.options.buttonOKText;
      }
      if (g_Dialog.options.buttonCancelText != undefined) {
        this.buttonCancelText = g_Dialog.options.buttonCancelText;
      }
      if (g_Dialog.options.toStringFn != undefined) {
        this.toStringFn = g_Dialog.options.toStringFn;
      }
      if (g_Dialog.options.tooltipFn != undefined) {
        this.tooltipFn = g_Dialog.options.tooltipFn;
      }
      if (g_Dialog.options.width != undefined) {
        this.width = g_Dialog.options.width;
      }
    }
  },
  mounted() {},
};
</script>
